<script setup lang="ts">
import { ref, computed, watchEffect } from "vue";
import { storeToRefs } from "pinia";
import type { MemberRechargePage2ListData } from "@/assets/API/APItype";
import { useMemberService } from "@/stores/memberFunction/memberService";

import ATMDeposit from "@/components/menberFunction/depositPage/ATMDeposit.vue";
import StoreDeposit from "@/components/menberFunction/depositPage/storeDeposit.vue";
import OnlineDeposit from "@/components/menberFunction/depositPage/onlineDeposit.vue";
import CompanyDeposit from "@/components/menberFunction/depositPage/companyDeposit.vue";
import UploadDeposit from "@/components/menberFunction/depositPage/uploadDeposit.vue";
import RecordDeposit from "@/components/menberFunction/depositPage/recordDeposit.vue";
import USDTDeposit from "@/components/menberFunction/depositPage/USDTDeposit.vue";
import USDT2Deposit from "@/components/menberFunction/depositPage/USDT2Deposit.vue";
import SubmitUSDTDeposit from "@/components/menberFunction/depositPage/SubmitUSDTDeposit.vue";
import AddStoreDeposit from "@/components/menberFunction/depositPage/AddStoreDeposit.vue";
import AddUSDT2Deposit from "@/components/menberFunction/depositPage/AddUSDT2Deposit.vue";
import SmallAmountDeposit from "@/components/menberFunction/depositPage/smallAmountDeposit.vue";

import SidebarWeb from "@/components/menberFunction/functionNavbar/sidebarWeb.vue";
import top_btn_p from "@image/memberFunction/common/top_btn_p.png";
import top_btn from "@image/memberFunction/common/top_btn.png";

const memberService = useMemberService();
const {
  MemberCompanyDepositMsg,
  // MemberCompanyDeposit,
  // MemberUSDTDeposit,
  MemberRecharge2List,
  DepositUSDTList,
} = storeToRefs(memberService);

const showDepositPage = ref<number>(97);
function changeDepositPage(page: number) {
  console.log("changeDepositPage1", page);
  showDepositPage.value = page;
  MemberCompanyDepositMsg.value = "";
}

const USDT2Info = computed(() => {
  const res = MemberRecharge2List.value.filter(
    (item): item is MemberRechargePage2ListData =>
      typeof item !== "string" && item.sName === "U幣"
  );

  return res;
});
</script>

<template>
  <div class="md:grid grid-cols-12 gap-x-[3vw] block gap-y-[1dvh] px-[1vw] pb-[10dvh] pt-0 md:pt-[3rem]">
    <SidebarWeb class="col-span-3 hidden md:block mb-[7dvh]" />
    <div class="col-span-9 relative">
      <div class="px-0 pt-0 pb-0 md:px-[5vw] md:pt-[2dvh] md:pb-[4dvh] relative z-10 web-gold-border rounded-[24px]">
        <p class="mt-[1dvh] text-[24px] text-primary font-bold hidden md:block">
          {{ $t("MemberFunction.Deposit.Deposit") }}
        </p>
        <div class="relative member-in-bg w-full h-full">
            <USDT2Deposit v-if="DepositUSDTList.length !== 0" :Info="USDT2Info" @changeDepositPage="changeDepositPage" />

            <AddUSDT2Deposit v-else @changeDepositPage="changeDepositPage" />
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.bg-100 {
  background-size: 100% 100%;
}

.deposit-scrollbar {}

.deposit-scrollbar::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}

/* Track */
.deposit-scrollbar::-webkit-scrollbar-track {
  background: #21252927;
  border-radius: 2px;
}

/* Handle */
.deposit-scrollbar::-webkit-scrollbar-thumb {
  background: #ffffff69;
  border-radius: 2spx;
}

/* Handle on hover */
.deposit-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #212529;
}
</style>
